import { AddShopCart, GetShopCart, RemoveShopCart } from "@/api/shopCart";
import {
  setLocalStorage,
  getLocalStorage,
  delLocalStorage,
} from "@/tools/localStorage";

// 確認購物車中有無符合的商品，返回排序編號
const GetShopCartItemIndex = (state, { product, options }) => {
  // 確認商品是否存在購物車
  let index = -1;

  // 客製化商品不堆疊，直接返回-1
  if (product.IsCustom == "Y") {
    return index;
  }

  // 檢查目前購物車中是否有商品ID與選項都符合的項目
  state.shopcart.forEach((item, itemIndex) => {
    if (item.productData.GoodsID == product.GoodsID) {
      if (
        item.activeOption[0] === options[0] &&
        item.activeOption[1] === options[1]
      ) {
        index = itemIndex;
      }
    }
  });
  return index;
};

// 確認有無符合的商品，返回排序編號
const GetProductIndex = (state, productID) => {
  // 確認商品是否存在
  let index = -1;
  state.productData.forEach((item, itemIndex) => {
    item.GoodsID == productID ? (index = itemIndex) : "";
  });
  return index;
};

// 檢查商品與選項是否有符合的庫存資訊
const CheckActiveOption = ({ product, options }, isCustom) => {
  if (isCustom == "Y") {
    let error = false;
    options.forEach((option) => {
      // 檢查每個選項是否存在
      const spec = product.CustomSpecList.filter(
        (item) => item.CustomSpecID == option
      );
      if (spec.length <= 0) {
        error = true;
      } else if (spec[0].SpecStatus == "N") {
        error = true;
      }
    });

    return error ? "error" : "";
  } else {
    // 檢查是否存在符合的庫存
    const stock = product.Stock.filter((item) => {
      return item.ColorID == options[0] && item.SizeID == options[1];
    });

    return stock.length > 0 ? stock[0] : "error";
  }
};

// 儲存本地購物車
const SetLocalShopCart = (shopcart) => {
  // LocalShopcart 格式
  // GoodsID,IsCustom,option1-option2-option3....,Amount
  let tmpList = "";

  shopcart.forEach((item, itemIndex) => {
    itemIndex != 0 ? (tmpList += ";") : "";
    if (item.isCustom == "Y") {
      // 客製化商品
      let specListText = "";
      item.activeOption.forEach((spec, specIndex) => {
        specIndex != 0 ? (specListText += "-") : "";
        specListText += spec;
      });
      tmpList += `${item.productData.GoodsID},Y,${specListText},${item.amount}`;
    } else {
      // 一般商品
      tmpList += `${item.productData.GoodsID},N,${item.activeOption[0]}-${item.activeOption[1]},${item.amount}`;
    }
  });
  // 若購物車為空則清除LocalStorage購物車，反之則存入
  tmpList == ""
    ? delLocalStorage("shopcart")
    : setLocalStorage("shopcart", tmpList);
};

const shopCartModule = {
  namespaced: true,
  state: () => ({
    shopcart: [], //購物車
    productData: null, //商品資料
  }),
  actions: {
    // 會員加入購物車
    async AddShopCart(
      { dispatch, commit },
      { product, options, amount, showMessage = false }
    ) {
      let shopCartItem = {
        GoodsID: product.GoodsID,
      };
      // 一般商品，帶入ColorID與SizeID
      if (product.IsCustom != "Y") {
        shopCartItem.ColorID = options[0];
        shopCartItem.SizeID = options[1];
      }
      // 客製化商品，將CustomSpecID轉為字串帶入
      else {
        shopCartItem.CustomSpecID = options.join();
      }

      const addResult = await AddShopCart(shopCartItem, amount);
      if (addResult.code == 302) {
        // token 過期，先清空購物車再新增至本地購物車
        commit("SetShopCart", []);
        commit("AddShopCart", {
          product: product,
          options: options,
          amount: amount,
        });
      } else {
        // call 取得購物車 api，更新購物車狀態，並依情況顯示加入購物車訊息
        dispatch("GetShopCart");
        showMessage
          ? commit("setShopCartMessageShowCount", 1, { root: true })
          : "";
      }
    },
    // 會員移除購物車商品
    async RemoveShopCart({ state, dispatch, commit }, { index, amount }) {
      let removeList = [];
      // 若數量為-1表示移除全部數量
      if (amount == -1) {
        removeList = state.shopcart[index].shopcartID;
      }
      // 除此之外放入該商品指定數量的ShopCartID
      else {
        for (let i = 0; i < amount; i++) {
          removeList.push(state.shopcart[index].shopcartID[i]);
        }
      }

      // removeList不為空時才執行
      if (removeList.length > 0) {
        const removeResult = await RemoveShopCart(removeList);
        if (removeResult.code == 302) {
          // token 過期，清空購物車
          commit("SetShopCart", []);
        } else {
          // 重新取得目前購物車狀態
          dispatch("GetShopCart");
        }
      }
    },
    // 取得會員購物車
    GetShopCart({ dispatch }) {
      // 檢查是否有會員token，若無則改為讀取本地ShopCart
      if (getLocalStorage("account_token")) {
        GetShopCart().then(async (res) => {
          if (res.code == 302) {
            // 若token過期則改為讀取本地ShopCart
            dispatch("GetLocalShopCart");
          } else {
            // 將API的購物車資訊轉換格式
            dispatch("ConvertShopCart", res.data);
          }
        });
      } else {
        dispatch("GetLocalShopCart");
      }
    },
    // 取得本地購物車
    GetLocalShopCart({ state, commit }) {
      // 從localStorage 讀出購物車
      let shopCartText = getLocalStorage("shopcart");
      // 暫存購物車
      let tmpList = [];

      if (shopCartText) {
        // 若有讀出購物車，則依照規則轉換成陣列
        shopCartText = shopCartText.split(";");

        shopCartText.forEach((item) => {
          // 購物車物品資料
          const shopcartItem = item.split(",");
          // 商品資料
          const productData = state.productData.filter(
            (item) => item.GoodsID == shopcartItem[0]
          );
          if (productData.length > 0) {
            // 檢查庫存是否存在
            const stockData = {
              product: productData[0],
              options: shopcartItem[2].split("-"),
            };

            let optionStatus = CheckActiveOption(stockData, shopcartItem[1]);

            // 若商品存在且庫存存在則新增至購物車
            if (optionStatus != "error") {
              tmpList.push({
                productData: productData[0],
                isCustom: shopcartItem[1],
                activeOption: shopcartItem[2].split("-"),
                amount: parseInt(shopcartItem[3]),
                shopcartID: [],
              });
            }
          }
        });
      }
      commit("SetShopCart", tmpList);
    },
    // API購物車格式轉換
    async ConvertShopCart({ dispatch, commit, state }, shopcart) {
      // 暫存購物車
      let tmpList = [];
      // 不存在的商品
      let deleteList = [];

      shopcart.forEach((item) => {
        // 檢查商品是否存在
        const productIndex = GetProductIndex(state, item.GoodsID);

        // 商品存在
        if (productIndex != -1) {
          const productData = state.productData[productIndex];
          let shopCartItem = {
            product: productData,
            options: [],
          };
          // 一般商品，帶入ColorID與SizeID
          if (productData.IsCustom != "Y") {
            shopCartItem.options = [item.ColorID, item.SizeID];
          }
          // 客製化商品，CustomSpecID轉為陣列帶入
          else {
            shopCartItem.options = item.CustomSpecID.split(",");
          }

          // 檢查選項是否存在
          const optionStatus = CheckActiveOption(
            shopCartItem,
            productData.IsCustom
          );
          // 檢查是否存在相同商品，客製化商品不疊加
          const shopCartItemIndex =
            productData.IsCustom != "Y"
              ? GetShopCartItemIndex({ shopcart: tmpList }, shopCartItem)
              : -1;

          if (optionStatus == "error") {
            // 若商品選項已不存在，則新增至待刪除清單
            deleteList.push(item.ShoppingCartID);
          } else if (shopCartItemIndex == -1) {
            // 如果商品不存在，則新增進暫存購物車
            let tmpShopcartItem = {
              productData: productData,
              activeOption: [],
              isCustom: productData.IsCustom,
              amount: 1,
              shopcartID: [item.ShoppingCartID],
            };
            if (productData.IsCustom != "Y") {
              tmpShopcartItem.activeOption = [item.ColorID, item.SizeID];
            } else {
              tmpShopcartItem.activeOption = item.CustomSpecID.split(",");
            }
            tmpList.push(tmpShopcartItem);
          } else {
            // 如果商品存在，則增加數量
            tmpList[shopCartItemIndex].amount += 1;
            tmpList[shopCartItemIndex].shopcartID.push(item.ShoppingCartID);
          }
        }
        // 若商品已不存在，則新增至待刪除清單
        else {
          deleteList.push(item.ShoppingCartID);
        }
      });

      // 移除不存在的商品後，設定購物車
      if (deleteList.length > 0) {
        const removeResult = await RemoveShopCart(deleteList);
        if (removeResult.code == 302) {
          // token 過期，清空購物車
          commit("SetShopCart", []);
        } else {
          // 移除商品後，重新取得目前購物車
          dispatch("GetShopCart");
        }
      } else {
        commit("SetShopCart", tmpList);
      }
    },
  },
  mutations: {
    // 非會員加入購物車
    AddShopCart(state, { product, options, amount, showMessage = false }) {
      // 搜尋購物車中相同商品的位置，若無相同商品則返回-1
      const productIndex = GetShopCartItemIndex(state, {
        product: product,
        options: options,
      });

      if (productIndex == -1) {
        // 若商品不存在則新增
        const shopcartItem = {
          productData: product,
          activeOption: options,
          isCustom: product.IsCustom,
          amount: amount,
          shopcartID: [],
        };
        state.shopcart.push(shopcartItem);
      } else {
        // 若商品存在則增加數量
        state.shopcart[productIndex].amount = parseInt(
          state.shopcart[productIndex].amount
        );
        state.shopcart[productIndex].amount += parseInt(amount);
      }
      // 儲存本地購物車
      SetLocalShopCart(state.shopcart);
      // 依情況顯示加入購物車訊息
      showMessage
        ? this.commit("setShopCartMessageShowCount", 1, { root: true })
        : "";
    },
    // 非會員移除購物車商品
    RemoveShopCart(state, { index, amount }) {
      if (amount == -1) {
        // 若數量為-1則直接將該商品移除
        state.shopcart.splice(index, 1);
      } else {
        // 若數量不為-1則扣除指定的數量
        state.shopcart[index].amount =
          parseInt(state.shopcart[index].amount) - parseInt(amount);
        // 若扣除數量後商品數量小於等於0，則移除該商品
        state.shopcart[index].amount <= 0
          ? state.shopcart.splice(index, 1)
          : "";
      }
      // 儲存本地購物車
      SetLocalShopCart(state.shopcart);
    },
    // 設定購物車資料
    SetShopCart(state, shopcart) {
      state.shopcart = shopcart;
      SetLocalShopCart(shopcart);
    },
    // 設定商品資料
    SetProductData(state, productData) {
      state.productData = productData;
    },
  },
};

export { shopCartModule };
